import QrPrintRequests from './QrPrintRequests'

export default QrPrintRequests
